import c3 from '@bower_components/c3';

export default {
  roomType: (result, bindto) => {
    c3.generate({
      bindto: bindto,
      data: {
        columns: result.data,
        type: 'donut'
      },
      color: {
        pattern: ['#aaa', '#2ca02c', '#ff8824', '#6993ba', '#69bab4']
      },
      donut: {
        label: {
          threshold: 0.02
        }
      },
      onrendered: function () {
        bindto.setAttribute('data-rendered', 'true');
      }
    });
  },
  roomUtilization: (result, bindto) => {
    c3.generate({
      bindto: bindto,
      data: {
        x: 'x',
        rows: result.data,
        groups: [['Frei', 'Belegt', 'Reserviert']],
        order: null,
        type: 'bar',
        colors: {
          Frei: '#d62728',
          Reserviert: '#ff8824',
          Belegt: '#2ca02c'
        }
      },
      axis: {
        x: {
          type: 'category' // this needed to load string x value
        },
        y: {
          tick: {
            format: d => {
              return Number(d).toLocaleString() + ' m²';
            }
          }
        }
      },
      grid: {
        y: {
          lines: [{ value: 0 }]
        }
      }, tooltip: {
        contents: function (d, defaultTitleFormat, defaultValueFormat, color) {
          d.push({
            id: 'Gesamt',
            index: 3,
            name: 'Gesamt',
            value: d.map(item => item.value).reduce((a, b) => a + b)
          });
          d = d.filter(item => item.value !== 0);
          return c3.chart.internal.fn.getTooltipContent.apply(
            this, [d, defaultTitleFormat, defaultValueFormat, color]);
        }
      }
    });
  },
  roomUsage: (result, bindto) => {
    var sums = [0, 0, 0];
    result.data.slice(1).forEach((typ, i) => {
      sums[i] += typ.slice(1).map(
        i => Number(i)).reduce((a, b) => a + b);
    });

    var usageData = result.data.map((typ, i) => {
      if (typ[0] === 'x') {
        return typ;
      }

      var d = typ.map(status => {
        if (isNaN(status)) {
          return status;
        }
        return status / sums[i - 1];
      });
      return d;
    });

    c3.generate({
      bindto: bindto, // $('#usage_rooms')[0],
      data: {
        x: 'x',
        rows: usageData,
        groups: [
            ['Belegt'],
            ['Frei', 'Reserviert']
        ],
        order: null,
        type: 'bar',
        colors: {
          Frei: '#d62728', // '#bb4444'
          Reserviert: '#ff8824',
          Belegt: '#2ca02c', // '#1ada55',
        }
      },
      axis: {
        x: {
          type: 'category' // this needed to load string x value
        },
        y: {
          max: 1.0,
          padding: {
            top: 0,
            bottom: 0
          },
          tick: {
            format: d => {
              return (100 * Number(d)).toFixed(1) + ' %';
            }
          }
        }
      },
      grid: {
        y: {
          lines: [{value: 0}]
        }
      },
      tooltip: {
        contents: function(d, defaultTitleFormat, defaultValueFormat, color) {
          d = d.filter(item => item.value !== 0);
          return c3.chart.internal.fn.getTooltipContent.apply(
            this, [d, defaultTitleFormat, defaultValueFormat, color]);
        }
      }
    });
  },
  totalFill: (result, bindto) => {
    var fills = result.data[0].slice(1).map((typ, i) => {
      return result.data.slice(1).map(
        n => Number(n[i + 1])).reduce((a, b) => a + b);
    });
    c3.generate({
      bindto: bindto, // $('#fill_rate')[0],
      data: {
        columns: [
            ['Vermietet',
             100 * fills[0] / fills.reduce((a, b) => a + b)]
        ],
        type: 'gauge'
      },
      gauge: {
        label: {
          format: function(value) {
            return Number(value).toFixed(1) + ' %';
          },
          show: false // to turn off the min/max labels.
        },
        // max: 100, // 100 is default
        units: ' %'
      },
      axis: {
        y: {
          tick: {
            format: d => {
              return Number(d).toFixed(2) + ' %';
            }
          }
        }
      },
      color: {
        pattern: ['#FF0000', '#F97600', '#F6C600', '#2ca02c'], // the three color levels for the percentage values.
        threshold: {
          values: [30, 60, 90, 100]
        }
      },
      size: {
        height: 100
      }
    });
  }
};
